import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './NCList.css';

function NCListSkeleton({ count = 5 }) {
  return (
    <div className="nc-list">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="nc-card skeleton-card">
          <div className="nc-card-header">
            <Skeleton width={120} height={24} />
            <Skeleton width={80} height={20} />
          </div>
          <div className="nc-card-body">
            <Skeleton width="60%" height={18} style={{ marginBottom: 8 }} />
            <Skeleton width="80%" height={16} style={{ marginBottom: 8 }} />
            <Skeleton width="40%" height={16} />
          </div>
          <div className="nc-card-footer">
            <Skeleton width={100} height={16} />
            <Skeleton width={60} height={16} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default NCListSkeleton;
